import React from 'react';
import { createUseStyles } from 'react-jss';
import { useT } from '../../i18n';

const MONO = 'ui-monospace, SFMono-Regular, Menlo, monospace';

/**
 * Shown to a player the host removed, over the whole board.
 *
 * It blocks the game rather than redirecting on its own — being dropped out of
 * a room mid-round without a word reads as a bug. `Back to menu` is also what
 * rotates the tab's playerId, so it is the deliberate act that earns a way
 * back in (see playerId.js).
 */
const useStyles = createUseStyles({
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'rgba(14,8,4,0.82)',
  },
  plate: {
    background: '#2a1d13',
    border: '1px solid #6b4622',
    borderRadius: '12px',
    padding: '26px 30px',
    maxWidth: '340px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    textAlign: 'center',
    boxShadow: [
      'inset 0 1px 0 rgba(255,255,255,0.14)',
      'inset 0 -3px 0 rgba(0,0,0,0.4)',
      '0 18px 50px rgba(0,0,0,0.55)',
    ].join(','),
  },
  label: {
    fontFamily: MONO,
    color: '#e35c36',
    fontSize: '10px',
    fontWeight: 700,
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  message: {
    color: '#f5e6c8',
    fontSize: '17px',
    lineHeight: 1.45,
  },
  hint: {
    color: '#c4a070',
    fontSize: '13px',
    lineHeight: 1.45,
  },
  btn: {
    marginTop: '6px',
    height: '46px',
    padding: '0 22px',
    background: '#d94f2b',
    border: 'none',
    borderRadius: '8px',
    color: '#fff3e8',
    cursor: 'pointer',
    fontFamily: MONO,
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    boxShadow: [
      'inset 0 1px 0 rgba(255,255,255,0.22)',
      'inset 0 -2px 0 rgba(0,0,0,0.28)',
      '0 3px 0 #7d2a12',
    ].join(','),
    '&:active': {
      transform: 'translateY(3px)',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.12), inset 0 2px 5px rgba(0,0,0,0.45)',
    },
  },
});

function KickedNotice({ onLeave }) {
  const classes = useStyles();
  const t = useT();

  return (
    <div className={classes.overlay} role="dialog" aria-modal="true">
      <div className={classes.plate}>
        <span className={classes.label}>{t('game.kickedTitle')}</span>
        <span className={classes.message}>{t('game.kickedMessage')}</span>
        <span className={classes.hint}>{t('game.kickedHint')}</span>
        <button type="button" className={classes.btn} onClick={onLeave}>{t('game.backToMenu')}</button>
      </div>
    </div>
  );
}

export default KickedNotice;
